import { render } from "./PresenterPanel.vue?vue&type=template&id=3acb038c&scoped=true"
import script from "./PresenterPanel.vue?vue&type=script&lang=js"
export * from "./PresenterPanel.vue?vue&type=script&lang=js"

import "./PresenterPanel.vue?vue&type=style&index=0&id=3acb038c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acb038c"]])

export default __exports__